var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack2Home(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5q-.625 0-1.062-.438Q8.5 10.625 8.5 10t.438-1.062Q9.375 8.5 10 8.5t1.062.438q.438.437.438 1.062t-.438 1.062q-.437.438-1.062.438Zm0 5.5q-2.917 0-4.969-2.042Q2.979 12.917 3 10h1.5q.042 2.292 1.635 3.896Q7.729 15.5 10 15.5q2.292 0 3.896-1.604T15.5 10q0-2.292-1.604-3.896T10 4.5q-1.229 0-2.323.531-1.094.531-1.906 1.469H8V8H3V3h1.5v2.708q1-1.291 2.438-2Q8.375 3 10 3q1.458 0 2.729.552 1.271.552 2.219 1.5t1.5 2.219Q17 8.542 17 10q0 1.458-.552 2.729-.552 1.271-1.5 2.219t-2.219 1.5Q11.458 17 10 17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2Home);
export default __webpack_public_path__ + "static/media/back2home.17de500574b61aef1b607b9b5a283773.svg";
export { ForwardRef as ReactComponent };